import { getApiErrorMessage } from "@/core/utils"

export const LEGACY_JOIN_GUIDANCE =
  "Устаревший join_approved нельзя создавать или активировать. Используйте telegram.joinChat.onApproved."

const messages = {
  "updates-disabled":
    "Обновления отключены: проверьте эффективную политику ролей клиента. Разрешение меняется только по явному решению пользователя.",
  "client-inactive": "Клиент неактивен",
  "client-unauthorized": "Клиент не авторизован",
  "unsupported-legacy-join-trigger": LEGACY_JOIN_GUIDANCE,
  "analysis-requires-history-download":
    "analysis-requires-history-download: для анализа явно разрешите скачивание истории; повторный запуск не даёт согласия.",
} as const

export const isLegacyJoinTrigger = (type: string) =>
  type.trim() === "join_approved"

export const triggerReasonLabel = (reason: unknown): string => {
  if (reason === null) return "—"
  if (reason === undefined) return "Неизвестно"
  return typeof reason === "string" && Object.hasOwn(messages, reason)
    ? messages[reason as keyof typeof messages]
    : "Неизвестная причина недоступности"
}

/** Policy errors inform an operator decision, never grant consent or retry. */
export const trafficPolicyErrorMessage = (error: unknown): string => {
  const message = getApiErrorMessage(error)
  const code = Object.keys(messages).find((key) => message.includes(key))
  return code ? messages[code as keyof typeof messages] : message
}
